import { render, staticRenderFns } from "./question-subscription.vue?vue&type=template&id=7bf6b794"
import script from "./question-subscription.vue?vue&type=script&lang=js"
export * from "./question-subscription.vue?vue&type=script&lang=js"
import style0 from "./question-subscription.vue?vue&type=style&index=0&id=7bf6b794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports